import { render, staticRenderFns } from "./articleManage.vue?vue&type=template&id=712223e4&scoped=true&"
import script from "./articleManage.vue?vue&type=script&lang=js&"
export * from "./articleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712223e4",
  null
  
)

export default component.exports